export const MAX_DISPLAY_COUNT = 200;
export const MAX_SELECTION_COUNT = 200;
